export const shouldLoad = () => document.querySelector('.klt-user-menu') !== undefined;